import type { PersonalizePricingExperience } from '~/amplienceTypes/schemas/imported/personalized-pricing-experience-schema';

type GetPpeJourneyContentParams = {
  ppeContent?: PersonalizePricingExperience[];
  trafficSource?: string | null;
  expirationDate?: string | null;
  formattedValue?: string | null;
  language?: string | null;
};

export const getPpeJourneyContent = ({
  ppeContent,
  trafficSource,
  expirationDate,
  formattedValue,
  language,
}: GetPpeJourneyContentParams): PersonalizePricingExperience => {
  const emptyContent = {} as PersonalizePricingExperience;

  if (!ppeContent?.length || !trafficSource || !expirationDate || !formattedValue || !language) {
    return emptyContent;
  }

  const endDate = new Date(expirationDate);

  if (Math.floor((endDate.getTime() - Date.now()) / 1000) < 0) {
    return emptyContent;
  }

  const deliveryKey = trafficSource.toLowerCase().replaceAll('_', '-');
  const content = ppeContent.find(
    item => (item.content as PersonalizePricingExperience)?._meta.deliveryKey === deliveryKey
  )?.content as PersonalizePricingExperience | undefined;

  if (!content) {
    return emptyContent;
  }

  const journeyContent: PersonalizePricingExperience = { ...content };

  if (content.uspText) {
    journeyContent.uspCountdown = {
      countdown: { endDate },
      text: content.uspText.replace('%P', formattedValue),
    };
  }

  if (typeof content.pdpText1?.html === 'string') {
    journeyContent.pdpText1 = {
      ...content.pdpText1,
      html: content.pdpText1.html.replace('%P', formattedValue),
    };
  }

  return journeyContent;
};
